// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"e8628900","320":"2cc307d7","342":"de593c69","464":"8d3b588c","569":"4bfc6103","742":"44348810","821":"e8628900"}[chunkId] + ".chunk.css";
};